/** @format */

import { AvailabilityMessage, ProductAvailability } from '@shared/data-access/interfaces';
import {
	ChangeDetectionStrategy,
	Component,
	Signal,
	computed,
	inject,
	input,
	output
} from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconSignCircledCancelFilled,
	homefieldIconSignCircledCheck
} from '@dsg-tech/homefield-angular-icons';
import { PICKUP_MESSAGES, SHIPPING_MESSAGES } from '@shared/data-access/constants';

import { HmfActionTextComponent } from '@dsg-tech/homefield-angular';
import { TitleCasePipe } from '@angular/common';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'common-product-availability',
	imports: [TitleCasePipe, HmfActionTextComponent, HomefieldIconLibraryModule],
	templateUrl: './product-availability.component.html',
	styleUrl: './product-availability.component.scss'
})
export class ProductAvailabilityComponent {
	readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	readonly isComingSoon = input(false);
	readonly isOOS = input(false);
	readonly selectedStoreName = input('');
	readonly showStoreNameInMessage = input(false);
	readonly clickSelectedStoreName = output();

	readonly productAvailabilityData: Signal<ProductAvailability | undefined> = input(undefined);
	readonly pickupMessage: Signal<AvailabilityMessage | undefined> = computed(() =>
		this.productAvailabilityData()
			? PICKUP_MESSAGES[this.productAvailabilityData().inStoreInventoryMessage]
			: undefined
	);
	readonly shippingMessage: Signal<AvailabilityMessage | undefined> = computed(() =>
		this.productAvailabilityData()
			? SHIPPING_MESSAGES[this.productAvailabilityData().onlineInventoryMessage]
			: undefined
	);

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconSignCircledCheck,
			homefieldIconSignCircledCancelFilled
		]);
	}
}
